<template>
  <div :class="['py-4 pt-4 rounded-b-lg', theme.middleScreen.backgroundColor]">
    <div
      class="flex overflow-x-scroll md:items-center md:justify-center overflow-y-scroll"
    >
      <div class="flex md:flex-col pb-6">
        <div
          :class="[
            'md:mb-4 mr-3 md:mr-0 w-24 h-20 rounded-md content-center flex items-center justify-center shadow-lg transition duration-500  hover:shadow-xl cursor-pointer',
            item.Id == selectedMenuCategory.Id
              ? theme.body.selectedBackgroundColor
              : theme.addToCart.backgroundColor,
          ]"
          v-for="item in menuCategories"
          v-bind:key="item.id"
          @click="getCategories(item)"
        >
          <div class="flex items-center w-full justify-end flex-col text-center">
            <div
              v-if="item.picture_url"
              :class="[
                'h-12 w-16 rounded-lg overflow-hidden flex items-center',
                theme.body.textColor,
              ]"
            >
              <img
                :src="item.picture_url"
                alt
                class="object-contain rounded-lg"
              />
            </div>
            <slot name="content" v-bind:data="item">
              <div class="flex-1">
                <div
                  :class="[
                    'font-medium text-xs',
                    item.Id == selectedMenuCategory.Id
                      ? theme.body.selectedTextColor
                      : theme.body.textColor,
                  ]"
                  v-trans:name="item"
                ></div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import lang from "../lang";
export default {
  data() {
    return {
      data: {
        type: Array,
        required: false,
      },
      link: {
        type: String,
        required: false,
      },
      lang: lang,
      currentItem: {},
      itemBeingAdded: "",
    };
  },
  computed: {
    isListDisplayed: {
      get() {
        return this.$store.getters["isListDisplayed"];
      },
      set(value) {
        this.$store.commit("updateIsListDisplayed", value);
      },
    },
    ...mapGetters([
      "language",
      "menuItems",
      "loadingItems",
      "currency",
      "theme",
      "selectedMenuCategory",
      "menuCategories",
    ]),
    ...mapGetters("Cart", ["cartItems"]),
  },
  methods: {
    getCategories(item) {
      this.$store.commit("updateSelectedMenuCategory", item);
      this.$store.commit("updateCategoryId", item.Id);
      this.$store.commit("updateIsSubSubCategory", false);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.Id);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);

        this.$router.push(
          "/" + this.$route.params.menuHash + "/category/" + item.Id
        ).catch(()=>{});
      } else {
        this.$store.dispatch("GET_CATEGORY");
        this.$router.push(
          "/" + this.$route.params.menuHash + "/sub/category/" + item.Id
        ).catch(()=>{});
      }
    },
    getSubItems(menuItemId) {
      this.$router.push(
        "/" +
          this.$route.params.menuHash +
          "/category/" +
          this.$route.params.categoryId +
          "/menuItemId/" +
          menuItemId
      ).catch(()=>{});
    },
  },
  mounted() {
    // console.log(this.$route);
    this.$store.commit("updateCategoryId", this.$route.params.categoryId);
  },
};
</script>